<template>
  <div class="flex items-center gap-3">
    <img src="/UClogo.png" alt="UCD Sign" height="40" width="40" style="height:40px;width:40px;border-radius:50%;object-fit:contain;">
    <span style="font-size:28px;font-weight:700;color:#2b123c;white-space:nowrap;">UCD Sign</span>
  </div>
</template>
